import bg from "assets/images/background/image-1.jpg";

const funFacts = [
  {
    id: 1,
    title: "Projects Completed",
    count: 110,
  },
  {
    id: 2,
    title: "Active clients",
    count: 25,
  },
  {
    id: 3,
    title: "Customer Satisfaction (%)",
    count: 99.9,
  },
  {
    id: 4,
    title: "happy clients (%)",
    count: 99.9,
  },
];

export const funFactsOne = {
  bg,
  funFacts,
};

export default funFacts;

export const funFactSix = [
  {
    id: 1,
    icon: "flaticon-architect",
    count: 6805,
    text: "Team Members",
  },
  {
    id: 2,
    icon: "flaticon-architect-1",
    count: 906,
    text: "Project Completed",
  },
  {
    id: 3,
    icon: "flaticon-buildings",
    count: 200,
    text: "Service Providing",
  },
  {
    id: 4,
    icon: "flaticon-satisfaction",
    count: 9760,
    text: "Happy Customers",
  },
];

export const funFactSeven = [
  {
    id: 1,
    count: 4789,
    text: "projects",
  },
  {
    id: 2,
    count: 6400,
    text: "customers",
  },
  {
    id: 3,
    count: 960,
    text: "success",
  },
  {
    id: 4,
    count: 378,
    text: "awards",
  },
];
